/* __next_internal_client_entry_do_not_use__ DropdownList,default auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import ClickOutside from "@faire/web--source/ui/ClickOutside";
import * as React from "react";
import styled, { css } from "styled-components";
/**
 * @trackcomponent
 */ export var DropdownList = function(props) {
    var className = props.className, classNameDropdown = props.classNameDropdown, classNameItem = props.classNameItem, style = props.style, specialOptionsCount = props.specialOptionsCount, renderOption = props.renderOption, options = props.options, open = props.open, getLabel = props.getLabel, getValue = props.getValue, appendage = props.appendage, onClose = props.onClose, children = props.children, height = props.height, getRef = props.getRef, emptyMessage = props.emptyMessage, center = props.center, allowPropogation = props.allowPropogation, onSelect = props.onSelect, onOpen = props.onOpen;
    var _React_useState = _sliced_to_array(React.useState(0), 2), highlightIndex = _React_useState[0], setHighlightIndex = _React_useState[1];
    var refs = React.useRef({});
    var handleSelectDropDown = function(event, index) {
        event.preventDefault();
        if (!allowPropogation) {
            event.stopPropagation();
        }
        select(index);
    };
    var select = function(selectIndex) {
        var selectedOption = options[selectIndex];
        var value = selectedOption ? getValue(selectedOption) : undefined;
        if (value !== undefined) {
            if (onSelect) {
                onSelect(value);
            } else if (onClose) {
                onClose();
            }
        }
    };
    var handleKeyUp = function(event) {
        if (event.key === "Enter" && open) {
            event.preventDefault();
            event.stopPropagation();
            select(highlightIndex);
        } else if (event.key === "Escape") {
            event.preventDefault();
            event.stopPropagation();
            if (onClose) {
                onClose();
            }
        }
    };
    var scrollIntoView = function(index) {
        var ref = refs.current[index];
        if (!ref) {
            return;
        }
        ref.scrollIntoView({
            block: "nearest"
        });
    };
    var handleKeyDown = function(event) {
        var optionLength = options.length;
        // Allow the enter key to go through, so that user can use enter key to select dropdown option
        var isRelevantKey = event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter";
        if (!isRelevantKey) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (event.key === "Enter") {
            return;
        }
        if (open) {
            var nextIndex = highlightIndex;
            switch(event.key){
                case "ArrowDown":
                    nextIndex = (highlightIndex + 1) % optionLength;
                    break;
                case "ArrowUp":
                    nextIndex = highlightIndex - 1 < 0 ? highlightIndex - 1 + optionLength : highlightIndex - 1;
                    break;
                default:
                    break;
            }
            scrollIntoView(nextIndex);
            setHighlightIndex(nextIndex);
        } else {
            onOpen === null || onOpen === void 0 ? void 0 : onOpen();
        }
    };
    var onHighlight = function(index) {
        return function() {
            setHighlightIndex(index);
        };
    };
    var highlightedOption = options[highlightIndex];
    var highlightValue = highlightedOption ? getValue(highlightedOption) : undefined;
    return /*#__PURE__*/ _jsx(Wrapper, {
        className: className,
        style: style,
        children: /*#__PURE__*/ _jsxs(ClickOutside, {
            onClickOutside: onClose,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            children: [
                children,
                open && (options.length || emptyMessage) ? /*#__PURE__*/ _jsxs(React.Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs(Dropdown, {
                            className: classNameDropdown,
                            style: {
                                height: height
                            },
                            "data-test-id": "dropdown_wrapper",
                            children: [
                                !options.length && emptyMessage && /*#__PURE__*/ _jsx(DropdownItem, {
                                    tabIndex: -1,
                                    className: classNameItem,
                                    $center: center,
                                    children: emptyMessage
                                }),
                                options.map(function(option, index) {
                                    if (renderOption) {
                                        return renderOption(option, function(event) {
                                            return handleSelectDropDown(event, index);
                                        }, onHighlight(index), highlightValue);
                                    }
                                    var label = getLabel(option);
                                    var value = getValue(option);
                                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                                        children: [
                                            !!specialOptionsCount && index === specialOptionsCount && /*#__PURE__*/ _jsx(HorizontalLine, {}),
                                            /*#__PURE__*/ _jsx(DropdownItem, {
                                                ref: function(el) {
                                                    if (!el) {
                                                        return;
                                                    }
                                                    refs.current[index] = el;
                                                },
                                                tabIndex: -1,
                                                className: classNameItem,
                                                onMouseDown: function(event) {
                                                    return handleSelectDropDown(event, index);
                                                },
                                                onMouseOver: onHighlight(index),
                                                $highlight: index === highlightIndex,
                                                "data-test-id": "dropdownItem_".concat(value),
                                                $center: center,
                                                children: label
                                            })
                                        ]
                                    }, "".concat(label, " ").concat(index));
                                }),
                                appendage
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            ref: getRef
                        })
                    ]
                }) : null
            ]
        })
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-d3b9ea30-0"
})([
    "display:flex;flex-direction:column;align-items:stretch;position:relative;cursor:pointer;.error{width:100%;display:block;",
    ";font-size:10px;letter-spacing:0.4px;padding:10px 0;text-align:left;}&.disabled{opacity:0.6;}&.disabled input{cursor:not-allowed !important;&:focus{border:solid 1px ",
    ";}}"
], TypographyStyles({
    color: "alert"
}), Core.border.muted);
var DropdownStyles = css([
    "display:block;width:100%;height:auto;max-height:230px;background-color:",
    ";border:solid 1px ",
    ";position:absolute;bottom:0px;transform:translate(0,100%);overflow:auto;"
], Core.surface.inverse, Core.border.muted);
var Dropdown = styled.div.withConfig({
    componentId: "sc-d3b9ea30-1"
})([
    "",
    ";z-index:2;"
], DropdownStyles);
var DropdownItem = styled.button.withConfig({
    componentId: "sc-d3b9ea30-2"
})([
    "height:43px;border:0;user-select:none;background:transparent;width:100%;display:block;cursor:pointer;text-align:left;padding:0 15px;",
    ";",
    ";"
], function(param) {
    var $center = param.$center;
    return $center ? css([
        "",
        ";"
    ], TypographyStyles({
        align: "center"
    })) : "";
}, function(param) {
    var $highlight = param.$highlight;
    return $highlight ? css([
        "background-color:",
        ";"
    ], Core.surface.subdued) : "";
});
export default DropdownList;
